import React, { FC, ReactNode } from 'react';
import { VisuallyHidden } from '@indeed/ifl-components';
import getTextClient from '../../../i18n/getTextClient';

interface MainContentProps {
    children: ReactNode;
}

const MainContent: FC<MainContentProps> = ({ children }) => {
    const gt = getTextClient.get();
    // # a11y; Start of the main content of the web site ;jobseekers
    const startOfMainContent = gt.pgettext(
        'Start of the main content of the web site',
        'Start of main content'
    );

    return (
        <div
            id="messaging-main-content"
            tabIndex={-1}
            style={{
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
            }}
        >
            <div>
                <VisuallyHidden>{startOfMainContent}</VisuallyHidden>
            </div>
            {children}
        </div>
    );
};

export default MainContent;
